import {
  Briefcase,
  Crown,
  Gem,
  Rocket,
  Shield,
  Sparkles,
  Star,
  Zap,
} from "lucide-react";

const ICON_MAP = {
  crown: Crown,
  shield: Shield,
  star: Star,
  sparkles: Sparkles,
  rocket: Rocket,
  gem: Gem,
  zap: Zap,
  briefcase: Briefcase,
};

export const getTierIconComponent = (iconKey) => {
  const normalizedKey = String(iconKey ?? "").trim().toLowerCase();
  return ICON_MAP[normalizedKey] ?? Crown;
};
